// extracted by mini-css-extract-plugin
export default {"pvrecWidgetWrapper":"pvrecWidgetWrapper--mp-o1vQA"};